/* The Hero checkout controller handles cart and checkout; this element syncs the offer summary. */
if (!customElements.get('ecommerce-growth-offer-price')) {
  customElements.define('ecommerce-growth-offer-price', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const variant = this.querySelector('select[name="id"]');
      variant?.addEventListener('change', () => {
        const option = variant.selectedOptions[0];
        if (!option) return;
        const price = this.querySelector('[data-offer-price]');
        const parts = option.dataset.price.split('.');
        price.setAttribute('aria-label', option.dataset.price);
        price.querySelector('[data-offer-whole]').textContent = parts.length === 2 ? parts[0] : option.dataset.price;
        const decimal = price.querySelector('[data-offer-decimal]');
        decimal.hidden = parts.length !== 2;
        decimal.textContent = parts.length === 2 ? '.' + parts[1] : '';
        const compare = this.querySelector('[data-offer-compare]');
        compare.hidden = !option.dataset.compare;
        compare.textContent = option.dataset.compare || '';
        const button = this.querySelector('button[type="submit"]');
        button.querySelector('.ego-cta-label').textContent = option.dataset.available === 'true' ? button.dataset.availableLabel : button.dataset.soldOutLabel;
      }, { signal: this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
